import { 
  collection, 
  getDocs,
  doc,
  query,
  where 
} from 'firebase/firestore'
import { projectFirestore } from '@/firebase/config'
import { getBookings, transformBookingsToCalendarFormat } from '@/composables/getBookings'
import { months } from '@/composables/Helpers'

export default {
  namespaced: true,
  
  state: {
    fetchedBookings: [],
    viewBookingDetails: {},
    viewBooking: false,
    viewOtherBookingDetails: {},
    viewOtherBooking: false,
  },

  mutations: {
    setFetchedBookings(state, bookings) {
      state.fetchedBookings = bookings
    },
    setViewBookingDetails(state, details) {
      state.viewBookingDetails = details
    },
    setViewBooking(state, value) {
      state.viewBooking = value
    },
    setViewOtherBookingDetails(state, details) {
      state.viewOtherBookingDetails = details
    },
    setViewOtherBooking(state, value) {
      state.viewOtherBooking = value
    }
  },

  actions: {
    async fetchBookings({ commit, rootState }, { month, year }) {
      try {
        const { bookings } = await getBookings(month, year)
        // Use same per-day format as calendar so month view indicators work after reschedule
        const transformedBookings = transformBookingsToCalendarFormat(bookings, month, year)
        // Merge instead of replace: keep entries for other months when refreshing multiple months (e.g. multi-day reschedule Jan-Feb)
        const refreshedMonthIndex = months.indexOf(month)
        const existing = rootState.fetchedBookings || []
        const filtered = existing.filter((b) => b.month !== refreshedMonthIndex)
        const merged = [...filtered, ...transformedBookings]
        commit('setFetchedBookings', merged)
        // Calendar and rest of app read root state.fetchedBookings; keep in sync so month view updates
        commit('SET_FETCHED_BOOKINGS', merged, { root: true })
        return merged
      } catch (error) {
        console.error('Error fetching bookings:', error)
        throw error
      }
    }
  }
} 